var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fs-3 lh-20" },
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c(
        "card",
        {
          staticClass: "jc-space card-manager p-4 flex-row",
          staticStyle: { "align-items": "center" },
          attrs: {
            "border-color": _vm.newCreditCardRequired ? "alert-50" : "gray-40"
          }
        },
        [
          _c("div", { staticClass: "flex-4 al-center" }, [
            _c("span", { staticClass: "bold" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Moyen de paiement")))
            ]),
            _vm._v(" "),
            _vm.hasPaymentSetup
              ? _c(
                  "div",
                  {
                    staticClass: "flex-row",
                    staticStyle: { "align-items": "center" }
                  },
                  [
                    _c("SaasIcon", {
                      attrs: { icon: _vm.icon, width: 24, height: 16 }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.fullName,
                          "popper-class": "w-320"
                        }
                      },
                      [
                        _c("span", { staticClass: "ml-2" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm.currentCreditCard.brand
                                )
                              ) +
                              " ***-" +
                              _vm._s(_vm.currentCreditCard.last4) +
                              "\n                        — " +
                              _vm._s(_vm.fullNameHtmlTruncated) +
                              "\n                    "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.newCreditCardRequired
                      ? _c("span", { staticClass: "ml-3 alert-50 semibold" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.expirationMessage) +
                              "\n                "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _c("div", [
                  _c("span", { staticClass: "alert-50 semibold" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$l10n.__("Aucun moyen de paiement renseigné")
                        ) +
                        "\n                "
                    )
                  ])
                ]),
            _vm._v(" "),
            _vm.nextPaymentDate
              ? _c(
                  "span",
                  {
                    staticClass: "gray-60",
                    class: { "ml-5": _vm.hasPaymentSetup }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Prochain paiement le ")) +
                        " " +
                        _vm._s(_vm.formatNextPaymentDate) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.hasPaymentSetup && !_vm.newCreditCardRequired
            ? _c(
                "div",
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.edit"),
                      type: "tertiary"
                    },
                    on: {
                      click: function($event) {
                        return _vm.openPopupPaymentManagerCard("edit")
                      }
                    }
                  })
                ],
                1
              )
            : _c("CompassButton", {
                attrs: { label: _vm.$t.__("common.actions.add_bank_card") },
                on: {
                  click: function($event) {
                    return _vm.openPopupPaymentManagerCard("add")
                  }
                }
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }